var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 297,
    viewBox: "0 0 213 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.913 146.6C212.913 66.5 164.913 0.199994 106.413 0.199994C48.2125 0.199994 0.2125 66.5 0.2125 146.6C0.2125 226.7 47.9125 293.3 106.413 293.3C132.213 293.3 155.913 280.4 172.113 262.1L200.613 296.6L212.913 286.1L182.313 249.8C200.613 224.9 212.913 187.7 212.913 146.6ZM171.813 237.2L137.913 196.4L125.613 206.6L161.913 250.1C147.813 266.6 128.013 277.4 106.413 277.4C56.6125 277.4 16.1125 219.5 16.1125 146.6C16.1125 74 56.6125 16.1 106.413 16.1C156.513 16.1 196.713 74 196.713 146.6C197.013 183.5 186.513 216.2 171.813 237.2Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperQ);
export default __webpack_public_path__ + "static/media/UPPER_Q.ed31cca41c368c45ab3b07a7f0fd67d2.svg";
export { ForwardRef as ReactComponent };